import React from "react";
import "./About.css";

function About() {
  return (
    <div className="about-container" id="about">
      <div>
        <p className=" text-center title"> OM OSS</p>
      </div>
      <div className="row pictures justify-content-center ">
        <div className=" col-sm-12  col-md-6  col-lg-6 col-xl-6  colum-img1 "></div>
        <div className=" col-sm-12 col-md-6 col-lg-6 colum-about pt-md-5 ">
          <p className="text-about ">
            Med en stor variation av tjänster som vi erbjuder , är vi säkra på
            att du kommer att bli nöjd med oss. Titta runt på vår hemsida och om
            du har några frågor eller funderingar är det bara att kontakta oss.
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;
